module.exports = __webpack_public_path__ + "img/invite-case03.5039447c.jpeg";